import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { environment } from '@env/environment';

export const environmentGuard: CanMatchFn = () => {
  const router = inject(Router);

  const isProduction = environment.currentEnvironment === 'production';

  if (isProduction) {
    return router.createUrlTree(['/']);
  }

  return true;
};
